import { ApiRest } from '../Api';

// Token de sesión del SDK de verificación de Legal (CORP-598). El backend toma
// RIF, razón social y dirección de su base y llama a legal-api con la API key:
// al navegador solo llega el `session_token`, opaco y de 30 min.
//
// Errores (`error_code`): 400 1188 ya activo, 1189 `new_verification` no
// permitido, 1191 RIF inválido, 1192 sin permiso; 409 1186 y 422 1187 datos del
// registro que no coinciden con el trámite; 502 1190 Legal no disponible. Va con
// `throwServerErrors` para que el 502 llegue al modal y no a la alerta global.

// ─── Types ────────────────────────────────────────────────────────────────────

export interface LegalSdkTokenRequest {
  /**
   * Abre un trámite nuevo. Solo cuando el último terminó `closed` y el owner lo
   * pide con el botón; si no, el backend responde 400 1189.
   */
  new_verification?: boolean;
}

export interface LegalSdkTokenApiResponse {
  success: boolean;
  message: string;
  session_token: string;
  expires_at: string;
}

// ─── API calls ────────────────────────────────────────────────────────────────

/** Devuelve solo el token: es lo único que necesita el SDK. */
export const requestLegalSdkToken = async (
  body: LegalSdkTokenRequest = {},
): Promise<string> => {
  const apiRest = new ApiRest();
  const res: LegalSdkTokenApiResponse = await apiRest.post({
    url: '/api/v1/corporate/auth/legal/sdk-token',
    body,
    throwServerErrors: true,
  });
  if (!res?.session_token) throw new Error('LEGAL_SDK_TOKEN_MISSING');
  return res.session_token;
};
